import { removeFormat as removeFormat_1 } from './removeFormat.locstring.json';
import loc from 'owa-localize';
import RibbonButton from './RibbonButton';

import { clearFormat } from 'roosterjs-editor-api';

const removeFormat: RibbonButton = {
    key: 'removeFormat',
    title: () => loc(removeFormat_1),
    imageSrc: require('../svg/removeformat.svg'),
    onExecute: plugin => clearFormat(plugin.getEditor()),
};

export default removeFormat;
